import React from 'react';

function InputIcon({
  icon: Icon,
  children,
  className = '',
  iconClassName = 'text-orange-500',
  position = 'left',
}) {
  const pad = position === 'left' ? 'input-icon-left' : 'input-icon-right';

  return (
    <div className={`input-icon-wrap ${pad} ${className}`.trim()}>
      {Icon && position === 'left' ? (
        <Icon className={`input-icon ${iconClassName}`} aria-hidden="true" />
      ) : null}
      {children}
      {Icon && position === 'right' ? (
        <Icon className={`input-icon ${iconClassName}`} aria-hidden="true" />
      ) : null}
    </div>
  );
}

export default InputIcon;
